/** Ajax 性能 */
import React from 'react';
import ReactEcharts from '../../../components/Echarts/ReactEcharts';

class HomeEcharts extends React.Component{
  timeIdx;
  // 重新绘制
  UNSAFE_componentWillReceiveProps = () => {
    clearTimeout(this.timeIdx);
    this.timeIdx = setTimeout(() => {
      if (this.refs.ajaxNature) {
        this.refs.ajaxNature.updateEcharts();
      }
    }, 60);
  };
  // 绘图
  getOption() {
    const {echartsData} = this.props;
    let requestTime = []; // 相应时间
    let requestTimes = []; // 调用量
    let time = [];
    echartsData.forEach(item => {
      requestTime.push(item.requestTime);
      requestTimes.push(item.requestTimes);
      time.push(item.time);
    });
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Ajax调用量', '响应时间'],
        right: 10
      },
      grid: {
        left: '15',
        right: '15',
        top: '40',
        bottom: '15',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          data: time
        }
      ],
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: '',
          min: 0,
          axisLabel: {
            formatter: function(value, index){
              return `{colorBlue|${value} ms}`
            },
            rich: {
              colorBlue: {
                color: '#0E76BB'
              },
            }
          },
          boundaryGap: [0.2, 0.2]
        }, {
          type: 'value',
          scale: true,
          name: '',
          min: 0,
          splitLine:{
            show: false
          },
          axisLabel: {
            formatter: function(value, index){
              return `{colorBlue|${value}}`
            },
            rich: {
              colorBlue: {
                color: '#F78E2F'
              },
            }
          },
          boundaryGap: [0.2, 0.2]
        }
      ],
      series: [
        {
          name: 'Ajax调用量',
          type: 'bar',
          yAxisIndex: 1,
          itemStyle : {
            color:'#F78E2F',
            lineStyle:{
              color:'#F78E2F'
            }
          },
          data: requestTimes
        }, {
          name: '响应时间',
          type: 'line',
          itemStyle : {
            color:'#0E76BB',
            lineStyle:{
              color:'#0E76BB'
            }
          },
          data: requestTime
        }
      ]
    };
    return option;
  };
  render() {
    const {echartsData} = this.props;
    return (
      <div className='card'>
        <ReactEcharts ref='ajaxNature' key='ajaxNature' option={this.getOption()} isHide={echartsData.length === 0} h={300}></ReactEcharts>
      </div>
    );
  }
};
export default HomeEcharts;
